import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import { sendLog } from '../../services/sentry/sentryLog.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './MicroFrontendErrorBoundary.module.scss.js';

var MicroFrontendErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(MicroFrontendErrorBoundary, _React$Component);
  var _super = _createSuper(MicroFrontendErrorBoundary);
  function MicroFrontendErrorBoundary(props) {
    var _this;
    _classCallCheck(this, MicroFrontendErrorBoundary);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleReload", function () {
      window.location.reload();
    });
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(MicroFrontendErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var microfrontend = this.props.microfrontend;
      sendLog(microfrontend, {
        error: error,
        errorInfo: errorInfo
      }, {
        errorType: "".concat(microfrontend, " crash")
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hasError = this.state.hasError;
      var children = this.props.children;
      if (hasError) {
        return /*#__PURE__*/React.createElement(Modal, {
          overlayClassName: styles.overlayWarning,
          className: styles.modalWarning,
          isOpen: true,
          shouldCloseOnOverlayClick: false
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.contentWrapper,
          id: "unrecoverable-dialog"
        }, /*#__PURE__*/React.createElement("h1", {
          className: classNames('title', styles.title)
        }, t('MPLIB_UNRECOVERABLE_ERROR_OCCURED_RELOAD_TITLE')), /*#__PURE__*/React.createElement("p", {
          className: styles.text
        }, t('MPLIB_UNRECOVERABLE_ERROR_OCCURED_RELOAD_DESC')), /*#__PURE__*/React.createElement("div", {
          className: styles.buttonBar
        }, /*#__PURE__*/React.createElement(Button, {
          dataTestId: "reload",
          text: t('MPLIB_RELOAD'),
          onClick: this.handleReload,
          className: styles.optionButton,
          flat: true
        }))));
      }
      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      }; //
    }
  }]);
  return MicroFrontendErrorBoundary;
}(React.Component);
MicroFrontendErrorBoundary.propTypes = {
  microfrontend: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export { MicroFrontendErrorBoundary as default };
